/* Meine Bestellungen - /pages/bestellungen (sections/mhsys-bestellungen.liquid). Geladen aus layout/theme.liquid nur auf
 * dieser Seite (template.suffix "bestellungen").
 *
 * 1. Uebergabe an den Bestellstatus: Klick auf "Details & Bestellstatus" legt "nummer|stelle|zeit" in sessionStorage
 *    mhsysBsOeffnen (assets/mhsys-bestellstatus.js liest und loescht es) - nie in der Adresse.
 * 2. Hinweise aus mhsys (Inhaber 26.09.2026): Adressfehler (fall "adresse", FAILADRESS) und fehlender Wunschtext
 *    (fall "wunschname") kennt nur mhsys. POST /apps/kunde?bereich=status&teil=meine liefert je Bestellung fall; bei
 *    den betroffenen wird der Hinweis eingeblendet. Bei der Adresse heisst der Knopf "Adresse korrigieren" und legt
 *    zusaetzlich mhsysBsAdresse = nummer ab: der Bestellstatus oeffnet das Formular dann gleich.
 *    Faellt die Abfrage aus, bleibt die Seite, wie sie ist - die Liste kommt aus Shopify, nichts fehlt.
 * 3. Nochmal bestellen ab dem Versand (siehe unten).
 * Werte nur per textContent.
 */
(function () {
  "use strict";
  var liste = document.querySelector(".mhsys-bestl__liste");

  document.addEventListener("click", function (e) {
    var a = e.target.closest ? e.target.closest("[data-bestl-oeffnen]") : null;
    if (!a) return;
    try {
      sessionStorage.setItem("mhsysBsOeffnen", a.getAttribute("data-bestl-oeffnen") + "|" + Date.now());
      if (a.hasAttribute("data-bestl-adresse")) sessionStorage.setItem("mhsysBsAdresse", a.getAttribute("data-bestl-adresse"));
      else sessionStorage.removeItem("mhsysBsAdresse");
    } catch (x) {}
  }, true);

  /* 3. Nochmal bestellen (Shop-Analyse 06.10.2026): dieselbe Mechanik wie im Bestellstatus (assets/mhsys-bestellstatus.js,
   *    wiederBestellen): /cart/add.js in den BESTEHENDEN Korb, _quelle "bestellstatus" (dieselbe Messung, orpo_quelle);
   *    nimmt Shopify den Stapel nicht, Artikel fuer Artikel weiter und die Meldung nennt, was fehlt. Danach die Schublade. */
  function inDenKorb(posten) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json", "X-Mhsys-Warenkorb": "1" },
      body: JSON.stringify({ items: posten.map(function (p) { return { id: Number(p.id), quantity: p.menge, properties: { _quelle: "bestellstatus" } }; }) }),
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok || j.status) throw new Error("nein");
        return j;
      });
    });
  }

  document.addEventListener("click", function (e) {
    var knopf = e.target.closest ? e.target.closest("[data-bestl-wieder]") : null;
    if (!knopf || knopf.disabled) return;
    var posten = [];
    try { posten = JSON.parse(knopf.getAttribute("data-bestl-wieder")) || []; } catch (x) { posten = []; }
    posten = posten.filter(function (p) { return p && /^[1-9][0-9]{0,19}$/.test(String(p.id)); }).map(function (p) {
      return { id: String(p.id), menge: Math.min(Math.max(parseInt(p.menge, 10) || 1, 1), 999), name: String(p.name || "") };
    });
    if (!posten.length) return;
    var eintrag = knopf.closest(".mhsys-bestl__eintrag");
    var meldung = eintrag && eintrag.querySelector("[data-bestl-wieder-meldung]");
    if (meldung) meldung.hidden = true;
    knopf.disabled = true;
    var fehlt = [];
    inDenKorb(posten)
      .catch(function () {
        return posten.reduce(function (kette, p) {
          return kette.then(function () { return inDenKorb([p]).catch(function () { fehlt.push(p.name); }); });
        }, Promise.resolve());
      })
      .then(function () {
        knopf.disabled = false;
        if (meldung && fehlt.length) {
          meldung.textContent = fehlt.length === posten.length
            ? "Die Artikel sind gerade leider nicht verfügbar."
            : "Gerade nicht verfügbar: " + fehlt.join(", ") + ". Alles andere liegt im Warenkorb.";
          meldung.hidden = false;
        }
        if (fehlt.length === posten.length) return;
        if (window.mhsysWarenkorb && document.querySelector("mhsys-warenkorb")) window.mhsysWarenkorb.aktualisieren(true);
        else window.location.href = "/cart";
      });
  });

  if (!liste) return;

  var TEXTE = {
    adresse: "Bei dieser Bestellung ist die Lieferadresse unvollständig. Bitte korrigier sie kurz – dann schicken wir dein Paket los.",
    wunschname: "Für diese Bestellung fehlt uns noch dein Wunschtext. Bitte schick ihn uns – dann können wir loslegen.",
  };

  fetch("/apps/kunde?bereich=status&teil=meine", {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: "{}",
    credentials: "same-origin",
    cache: "no-store",
  })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (a) {
      if (!a || !a.ok || !Array.isArray(a.bestellungen)) return;
      a.bestellungen.forEach(function (b) {
        var fall = String(b && b.fall || "");
        if (!TEXTE[fall]) return;
        var nummer = String(b.nummer || "");
        var eintrag = null;
        liste.querySelectorAll("[data-bestl-nummer]").forEach(function (li) {
          if (li.getAttribute("data-bestl-nummer") === nummer) eintrag = li;
        });
        if (!eintrag) return;
        var hinweis = eintrag.querySelector("[data-bestl-warnung]");
        if (hinweis) { hinweis.textContent = TEXTE[fall]; hinweis.hidden = false; }
        var knopf = eintrag.querySelector("[data-bestl-status]");
        if (knopf && fall === "adresse") {
          knopf.textContent = "Adresse korrigieren";
          knopf.classList.remove("mhsys-knopf--rand");
          knopf.setAttribute("data-bestl-adresse", nummer);
        }
      });
    })
    .catch(function () {});
})();
